// business-profile
import ProfileUploadImg from './business-profile/profile-upload-button.png';

// customer-center
import EuMailIconImg from './customer-center/eu-mail-icon.png';
import EuMegagenImg from './customer-center/eu-megagen-img.png';
import EuPhoneIconImg from './customer-center/eu-phone-icon.png';
import HqMegagenImg from './customer-center/hq-megagen-img.png';
import LibraryIcon from './customer-center/library-icon.png';
import HqMailIconImg from './customer-center/mail-icon.png';
import NavigateArrowImg from './customer-center/navigate-arrow.png';
import Number1 from './customer-center/number1.png';
import Number2 from './customer-center/number2.png';
import HqPhoneIconImg from './customer-center/phone-icon.png';
import QrCodeSctionImg from './customer-center/qr-code-section.png';

// error
import DropdownArrow from './dropdown/icon-dropdown.svg';
import NetworkErrorImage from './error/icon-network-error.png';
import NotFoundImage from './error/icon-not-found.png';
import AttachedFile from './file/icon-attached-file.svg';
import FileDelete from './file/icon-file-delete.svg';
import FileDownloadSpinner from './file/icon-file-download-spinner.svg';
import FileDownload from './file/icon-file-download.svg';
import FileError from './file/icon-file-error.svg';
import FileUpload from './file/icon-file-upload.svg';
import IconEyeClose from './input/icon-eye-close.svg';
import IconEyeOpen from './input/icon-eye-open.svg';

// header
import EnglishLangImg from './header/english-lang.png';
import KoreaLangImg from './header/korea-lang.png';
import Logo from './header/logo.png';
import R2PlaygroundLogo from './header/r2-playground-logo.svg';

// layout
import LoginBackground from './layout/login-background.png';

// loading
import LoadingSpinnerGif from './loading/loading-spinner.gif';

// logo
import IllustLogin from './logo/illust-login.png';

// main
import DashboardCalendarIcon from './main/dashboard-calendar.png';
import DashboardHeartIcon from './main/dashboard-heart.png';
import DashboardOrderIcon from './main/dashboard-order.png';
import DashboardStarIcon from './main/dashboard-star.png';
import MainImg from './main/main-img.png';
import MainPointImg1 from './main/main-point-img1.png';
import MainPointImg2 from './main/main-point-img2.png';

// modal
import Ximg from './modal/x-img.png';

// my-player-list
import ChatIcon from './my-player-list/chat-icon.png';

// navbar
import ProfileTestImg from './navbar/icon-profile.png';
import LogoutImg from './navbar/logout-img.png';
import NavBusinessProfileIcon from './navbar/nav-business-profile.png';
import NavCompletedOrderIcon from './navbar/nav-completed-order.png';
import NavDashboardIcon from './navbar/nav-dashboard-icon.png';
import NavMyPlayerIcon from './navbar/nav-my-player.png';
import NavOrderListIcon from './navbar/nav-order-list-icon.png';
import NavServiceAddIcon from './navbar/nav-service-add.png';
import NavCustomerCenterIcon from './navbar/nav-customer-center.png';

// notification
import OrderCrownBridgeImage from './notification/order-crown-bridge.png';
import OrderFaceGideImage from './notification/order-face-gide.png';
import OrderMegAlignerImage from './notification/order-meg-aligner.png';
import OrderR2GuideImage from './notification/order-r2-guide.png';
import OrderQvdImg from './notification/order-qvd.png';
import ErrorDeliverableImg from './notification/error-deliverable.png';

// partner
import PartnerOrderIcon from './navbar/partner/order-icon.svg';

// order-list
import CheckBoxImg from './order-list/check-box.png';
import RefreshIcon from './order-list/refresh-icon.png';
import StatusArrowImg from './order-list/satus-arrow-img.png';
import SearchIcon from './order-list/search-icon.png';
import SelectDownArrowImg from './order-list/select-down-arrow.png';
import SelectedCheckBoxImg from './order-list/selected-check-box.png';
import SelectedStatusArrowImg from './order-list/selected-status-arrow-img.png';
import StatusRejectIcon from './order-list/status-reject-icon.png';

// order-detail
import DesignCheckBoxImg from './order-list/order-detail/check-box.png';
import SelectedDesignCheckBoxImg from './order-list/order-detail/select-check-box.png';
import AttachedFileIcon from './order-list/order-detail/attched-file-icon.png';
import ConfirmFileIcon from './order-list/order-detail/confirm-file-icon.png';
import DeleteButtonImg from './order-list/order-detail/delete-button.png';
import DesignFileIcon from './order-list/order-detail/design-file-icon.png';
import DetailHoverIcon from './order-list/order-detail/detail-hover-icon.png';
import DetailIcon from './order-list/order-detail/detail-icon.png';
import DownloadButtonImg from './order-list/order-detail/download-button.png';
import FileUploadIcon from './order-list/order-detail/file-upload-icon.png';
import OptionDownArrowImg from './order-list/order-detail/option-down-arrow.png';
import OptionIcon from './order-list/order-detail/option-icon.png';
import OrderLogIcon from './order-list/order-detail/order-log-icon.png';

// search
// import ChatIcon from './order/icon-chat.svg';
import OrderHistory from './order/icon-order-history.svg';
import OrderTag from './order/icon-order-tag.svg';
import IconSearchReset from './search/icon-reset.svg';
import IconSearch from './search/icon-search.svg';

// service-registration
import ActiveServiceAddIceon from './service-registration/active-service-add-icon.png';
import CenterImg from './service-registration/center-img.png';
import CrownBridgeImg from './service-registration/crown-bridge-img.png';
import DisableServiceAddIcon from './service-registration/disable-service-add-icon.png';
import FaceGideImg from './service-registration/face-gide-img.png';
import MegAlignerImg from './service-registration/meg-aligner-img.png';
import OnOffImg from './service-registration/OnOffImg.png';
import PlannerImg from './service-registration/planner-img.png';
import PlustButtonImg from './service-registration/plus-button.png';
import QvdImg from './service-registration/qvd-img.png';
import R2GuideImg from './service-registration/r2-guide-img.png';

export const Images = {
  // ! business-profile
  ProfileUploadImg,
  // ! customer-center
  EuMailIconImg,
  EuMegagenImg,
  EuPhoneIconImg,
  HqMegagenImg,
  LibraryIcon,
  HqMailIconImg,
  NavigateArrowImg,
  Number1,
  Number2,
  HqPhoneIconImg,
  QrCodeSctionImg,
  // error
  NotFoundImage,
  NetworkErrorImage,
  // header
  EnglishLangImg,
  KoreaLangImg,
  Logo,
  R2PlaygroundLogo,
  // input
  IconEyeClose,
  IconEyeOpen,
  // layout
  LoginBackground,
  // loading
  LoadingSpinnerGif,
  // logo
  IllustLogin,
  // main
  DashboardCalendarIcon,
  DashboardHeartIcon,
  DashboardOrderIcon,
  DashboardStarIcon,
  MainImg,
  MainPointImg1,
  MainPointImg2,
  // !modal
  Ximg,
  // ! my-player-list
  ChatIcon,
  // navbar
  PartnerOrderIcon,
  // ! order-list
  CheckBoxImg,
  RefreshIcon,
  StatusArrowImg,
  SearchIcon,
  SelectDownArrowImg,
  SelectedCheckBoxImg,
  SelectedStatusArrowImg,
  StatusRejectIcon,
  // ! order-detail
  DesignCheckBoxImg,
  SelectedDesignCheckBoxImg,
  AttachedFileIcon,
  ConfirmFileIcon,
  DeleteButtonImg,
  DesignFileIcon,
  DetailHoverIcon,
  DetailIcon,
  DownloadButtonImg,
  FileUploadIcon,
  OptionDownArrowImg,
  OptionIcon,
  OrderLogIcon,
  // search
  IconSearch,
  IconSearchReset,
  // navbar
  ProfileTestImg,
  LogoutImg,
  NavBusinessProfileIcon,
  NavCompletedOrderIcon,
  NavDashboardIcon,
  NavMyPlayerIcon,
  NavOrderListIcon,
  NavServiceAddIcon,
  NavCustomerCenterIcon,
  // notification
  OrderCrownBridgeImage,
  OrderFaceGideImage,
  OrderMegAlignerImage,
  OrderR2GuideImage,
  OrderQvdImg,
  ErrorDeliverableImg,
  // service-registration
  ActiveServiceAddIceon,
  CenterImg,
  CrownBridgeImg,
  DisableServiceAddIcon,
  FaceGideImg,
  MegAlignerImg,
  OnOffImg,
  PlannerImg,
  PlustButtonImg,
  QvdImg,
  R2GuideImg,
  // dropdown
  DropdownArrow,
  // order
  OrderTag,
  OrderHistory,
  // file
  AttachedFile,
  FileUpload,
  FileDelete,
  FileDownload,
  FileDownloadSpinner,
  FileError,
};
